import { useEffect, useState } from 'react';

// Calculate the page scale ratio to shrink down the page content when the viewport's height is too small to render the
// page properly.
const useWindowHeightChanged = () => {
  const [windowHeight, setWindowHeight] = useState(0);

  useEffect(() => {
    setWindowHeight(window.innerHeight);

    const handleEvents = () => {
      setWindowHeight(window.innerHeight);
    };

    handleEvents();

    window.addEventListener('orientationchange', handleEvents);
    window.addEventListener('resize', handleEvents);
    const intervalHandler = setInterval(() => {
      handleEvents();
    }, 1000);

    return () => {
      window.removeEventListener('orientationchange', handleEvents);
      window.removeEventListener('resize', handleEvents);
      clearInterval(intervalHandler);
    };
  }, []);

  return windowHeight;
};

export default useWindowHeightChanged;
